import {
  browserTracingIntegration,
  captureRouterTransitionStart,
  // consoleLoggingIntegration,
  init,
  replayIntegration,
} from '@sentry/nextjs';

init({
  dsn: 'https://65c0fb48082f46dfbf9e5b67919129ed@o335794.ingest.us.sentry.io/4505235252707328',
  // Enable logs to be sent to Sentry
  // _experiments: { enableLogs: true },
  // Add optional integrations for additional features
  integrations: [
    replayIntegration(),
    browserTracingIntegration(),
    // consoleLoggingIntegration({ levels: ['log', 'error', 'warn'] }),
  ],
  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 1,
  // Define how likely Replay events are sampled.
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,
  // Define how likely Replay events are sampled when an error occurs.
  replaysOnErrorSampleRate: 1.0,
  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,
});

export const onRouterTransitionStart = captureRouterTransitionStart;
